// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fcbo","label":"styles_label__VpfZT"};